import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/edit_dynamic.png';
import _imports_1 from '@/assets/imgs/dynamicTopicImg/ic_tips.png';
import _imports_2 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-0ca4e896"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "action-buttons"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "24px",
    "height": "24px"
  }
}, null, -1));

const _hoisted_6 = ["src"];
const _hoisted_7 = {
  key: 0,
  class: "mg-r--10"
};
const _hoisted_8 = {
  class: "mg-r--10"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer",
    "height": "12px",
    "width": "12px"
  },
  src: _imports_2,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  key: 3,
  class: "buttons__list",
  style: {
    "display": "flex",
    "flex-wrap": "wrap",
    "gap": "0 10px"
  }
};
const _hoisted_14 = {
  class: "mg-b--5"
};
const _hoisted_15 = ["src"];
import { inject, ref, reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { usePageConfig } from '@/utils/useComponentConfig';
import { useCommon } from '@/store/useCommon';
import { elMessage } from '@/utils';
import DynamicTableHeader from '@/views/operating/productOperations/RecommendOperation/components/DynamicTableHeader/index.vue';
import MultiLangDialog from './multiLangDialog.vue';
import TwoLangDialog from './twoLangDialog.vue';
import { editDynamicPlanRecommendApi, editThemeTitleApi, switchDynamicPlanRecommendApi } from '@/api/topic';
import { ElMessage } from 'element-plus';
import TableConfigDialog from './tableConfigDialog.vue';
import RecommendConfig from './recommendConfig.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    dynamicData: {
      type: Object,
      default: () => ({
        extra: {
          recommendedSort: ''
        }
      })
    },
    sortOperations: {
      type: Array,
      default: () => []
    },
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'addPlan', 'uploadImg', 'onAddSubCategory', 'onEdit', 'onCopy', 'onDelete', 'onAssociate', 'onUpdateList', 'configOk'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const storeCommon = useCommon();
    const loading = ref(false);
    const langObj = ref({
      visible: false,
      data: null,
      //添加标题||二级分类标题 secondTitle
      mode: 'title',
      //传给接口的vodplusDynamicOperationPlanThemeComponentId
      componentId: undefined
    });
    const configObj = ref({
      visible: false,
      data: null
    });
    const recommendObj = ref({
      visible: false,
      data: null
    }); // 计算表格应该用哪种类型布局
    // 特殊处理单行/双行电影模板，其他模板根据key-value来找到对应的配置

    const computTableType = computed(() => {
      if (!props.dynamicData || !props.dynamicData.templateCode) {
        return columnConfig.dynamicColumnList1;
      } // 匹配双行、单行模板


      let singleOrDoubleTemplate = regex.test(props.dynamicData.templateCode);
      let isVideoType = props.dynamicData.type === 'video';

      if (singleOrDoubleTemplate && isVideoType) {
        // 单行||双行-电影模板
        return columnConfig.dynamicColumnList1;
      } else {
        // 单行-分类模板 及 其他模板
        return columnConfig[tableColumnKeys[props.dynamicData.templateCode]] || columnConfig.dynamicColumnList1;
      }
    }); // 表头配置

    const headerConfig = reactive({
      formData: props.dynamicData.componentTitleList,
      formList: [{
        label: '分类终端名称',
        prop: 'title',
        widgetType: 'input',
        itemSlot: true,
        dialogType: 0,
        controller: () => {
          return props.dynamicData.templateCode !== 'stb_left_side_property';
        }
      }]
    }); // 打开语言弹框

    const handleOpenLangDialog = (row, type) => {
      try {
        // type: 0=> 仅编辑标题 1=>编辑标题和二级标题
        let defaultData = [{
          title: '',
          language: 'en',
          id: null,
          secondTitle: '',
          vodplusDynamicOperationPlanThemeComponentId: props.dynamicData.id
        }];

        switch (type) {
          case 0:
            langObj.value.mode = props.dynamicData.templateCode === 'stb_left_side_property' ? 'secondTitle' : 'title';
            langObj.value.visible = true;
            langObj.value.data = row.length ? row : defaultData;
            langObj.value.componentId = row.length ? row[0].vodplusDynamicOperationPlanThemeComponentId : defaultData[0].vodplusDynamicOperationPlanThemeComponentId;
            break;

          case 1:
            // 配置弹框需要的初始数据,categories每个都要带id，name
            // subCategoryIdList: 关联的子分类id列表 [1,2,3]
            let subCategoryIdList = props.dynamicData.themeComponentItemList[0].extra.subCategoryId ? props.dynamicData.themeComponentItemList[0].extra.subCategoryId : [];
            let dataList = row.length ? row.map(item => {
              let categoryList = item.categoryList ? item.categoryList : subCategoryIdList.map(id => {
                return {
                  title: '',
                  categoryId: id
                };
              });
              return { ...item,
                categoryList
              };
            }) : defaultData;
            console.log('dataList', dataList);
            twoLangObj.value = {
              visible: true,
              data: dataList,
              subCategoryIdList,
              componentId: row.length ? row[0].vodplusDynamicOperationPlanThemeComponentId : defaultData[0].vodplusDynamicOperationPlanThemeComponentId,
              // 弹框显示的分类数量按照标题的数量确定
              categoryCount: subCategoryIdList.length ? subCategoryIdList.length : 1
            };
            break;
        }
      } catch (error) {
        console.log('235err', error);
      }
    };

    const twoLangObj = ref({
      visible: false,
      data: null,
      componentId: undefined,
      categoryCount: 1,
      subCategoryIdList: []
    });
    const STATUS_FIELD = {
      waiting: {
        value: t('待执行'),
        color: '#F2994A'
      },
      running: {
        value: t('执行中'),
        color: '#29B87D'
      },
      end: {
        value: t('已结束'),
        color: '#B4B4B4'
      },
      disable: {
        value: t('状态不对，要后端改后续删掉'),
        color: '#B4B4B4'
      },
      enable: {
        value: t('状态不对，要后端改后续删掉'),
        color: '#B4B4B4'
      }
    }; // provide('STATUS_FIELD', STATUS_FIELD)
    // 根据moduleType动态配置推荐方式

    const recommendTypeOperations = computed(() => {
      const options = [{
        label: t('影片推荐'),
        value: 'video'
      }, {
        label: t('分类推荐'),
        value: 'category'
      }]; // const moduleType = pageParams?.moduleType
      // if (moduleType === 'VOD_PRO') {
      //     options.push({ label: t('分类推荐'), value: 'type' })
      // } else if (moduleType === 'VOD_PLUS') {
      //     options.push({ label: t('分类推荐'), value: 'category' })
      // } else {
      //     // 兜底：默认按 vod_plus 行为
      //     options.push({ label: t('分类推荐'), value: 'category' })
      // }

      return options;
    }); // 推荐方式改变

    const onRecommendedSortChange = async (row, val) => {
      // 本地兜底，确保 extra 存在
      if (!row.extra) {
        row.extra = {
          recommendedSort: ''
        };
      }

      row.extra.recommendedSort = val ?? '';
      loading.value = true;

      try {
        let params = {
          id: row.id,
          extra: row.extra
        };
        const res = await editDynamicPlanRecommendApi(params);

        if (res.code == '0') {
          elMessage('success', '编辑成功');
          emits('onUpdateList');
        }
      } catch (error) {
        console.log('1058-error', error);
        emits('onUpdateList');
      }

      loading.value = false;
    };

    const tableOptionsBtn = ref([{
      label: '关联分类',
      func: async row => {
        console.log('row', row);
        let newRowData = { ...row,
          templateCode: props.dynamicData.templateCode
        };
        emits('onAssociate', newRowData);
      },
      controller: row => {
        // 判断是否为父级 是 -> 显示
        // 且不能是盒端推荐位模板，也不能是手机端推荐位模板
        // 单行双行分类且类型是video也不显示
        const {
          templateCode,
          type
        } = props.dynamicData;
        const singleOrDoubleTemplate = regex.test(templateCode);
        const isVideoType = type === 'video';
        const isExcludedTemplate = ['stb_d_h_r1r6_recommended', 'phone_s_h_r1_recommend'].includes(templateCode);
        const isFixedTemplate = /stb_fix\d/.test(templateCode);
        const isInvalidSingleVideo = singleOrDoubleTemplate && isVideoType;
        return !isExcludedTemplate && !isFixedTemplate && !isInvalidSingleVideo || ['category', 'type'].includes(row.recommendedType);
      }
    }, {
      label: '添加计划',
      func: row => {
        emits('addPlan', row);
      },
      controller: row => {
        // 盒端推荐位模板、手机端推荐位模板、盒端圆形推荐位模板可以显示
        // 单行(双行)分类且类型是video
        let singleOrDoubleTemplate = regex.test(props.dynamicData.templateCode);
        let isVideoType = props.dynamicData.type === 'video';
        let showBtn = props.dynamicData.templateCode === 'stb_d_h_r1r6_recommended' || props.dynamicData.templateCode === 'phone_s_h_r1_recommend' || /stb_fix\d/.test(props.dynamicData.templateCode) || singleOrDoubleTemplate && isVideoType;
        return showBtn && !['category', 'type'].includes(row.recommendedType);
      }
    }, {
      label: '推荐配置',
      func: row => {
        console.log('点了推荐配置', row);
        recommendObj.value.visible = true;
        recommendObj.value.data = row;
      },
      controller: row => {
        return row.dynamicRecommend;
      }
    }, {
      label: '上传图片',
      func: row => {
        //console.log('上传动态主题的图片',row)
        emits('uploadImg', row);
      },
      controller: row => {
        // 动态模板上传图片： 类型：分类、分类+更多不可用，推荐方式：分类推荐可用
        return props.dynamicData.type !== 'category_more' && props.dynamicData.type !== 'category' && ['category', 'type'].includes(row.recommendedType) && props.dynamicData.templateCode !== 'stb_s_h_r6_category' && props.dynamicData.templateCode !== 'stb_d_h_r6r6_category' && props.dynamicData.templateCode !== 'stb_left_side_property';
      }
    }, {
      label: '编辑',
      func: row => {
        emits('onEdit', row);
      },
      controller: row => {
        return !row.isParent;
      }
    }, {
      label: '复制',
      func: row => {
        emits('onCopy', row);
      },
      controller: row => {
        // 判断是否为父级 是 -> 不显示
        return !row.isParent;
      }
    }, {
      label: '删除',
      func: row => {
        // 判断是否为分类表格, 分类表格的删除不做限制
        let isCategoryTable = tableColumnKeys[props.dynamicData.templateCode] === 'dynamicColumnList2';
        emits('onDelete', { ...row,
          isCategoryTable
        });
      },
      controller: row => {
        // 判断是否为父级且状态不能为执行中 是 -> 不显示
        return !row.isParent && row.status !== 'enable';
      }
    }, {
      label: '添加子推荐位',
      func: async row => {
        emits('onAddSubCategory', row);
      },
      controller: row => {
        // 判断是否为父级 是 -> 显示
        return row.isParent; //&& row.recommendedType === 'video'
      }
    }]);
    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      showPageBar: false,
      config: {
        loading: false
      },
      rowKey: 'serialId'
    });
    /**目标匹配项
     * 双行 stb_d_h_r2r3,stb_d_h_r3r4, stb_d_h_r3r3, stb_d_h_r4r4, stb_d_h_r2r4, stb_d_h_r6r6
     * 单行 stb_s_v_r2, stb_s_v_r3, stb_s_v_r4, stb_s_v_r6, stb_s_h_r2,  stb_s_h_r3, stb_s_h_r4 stb_s_c_r6
     * 手机端 phone_d_v_r3r3, phone_s_h_r2,  phone_s_v_r3
     */

    const regex = /^(stb_d_h_r(?:2r3|3r4|3r3|4r4|2r4|6r6)|stb_s_(?:v_r[2346]|h_r[234]|c_r6)|phone_(?:d_v_r3r3|s_h_r[23]|s_v_r3))$/; // 根据对应Key在columnConfig中拿到对应的表格列表

    const tableColumnKeys = {
      // 盒端模板控件   
      stb_d_h_r6r6_recommend: 'dynamicColumnList2',
      // 横版推荐 不显示推荐方式一列，在controller中控制  25.12.8 测试提的
      stb_d_h_r1r6_recommended: 'dynamicColumnList1',
      stb_s_c_r6: 'dynamicColumnList2',
      stb_left_side_property: 'dynamicColumnList2',
      //双行模板 
      stb_d_h_r2r3: 'dynamicColumnList2',
      stb_d_h_r3r4: 'dynamicColumnList2',
      stb_d_h_r3r3: 'dynamicColumnList2',
      stb_d_h_r4r4: 'dynamicColumnList2',
      stb_d_h_r2r4: 'dynamicColumnList2',
      stb_d_h_r6r6: 'dynamicColumnList2',
      // 单行模板
      stb_s_v_r2: 'dynamicColumnList2',
      stb_s_v_r6: 'dynamicColumnList2',
      stb_s_h_r2: 'dynamicColumnList2',
      stb_s_h_r3: 'dynamicColumnList2',
      stb_s_h_r4: 'dynamicColumnList2',
      stb_s_v_r3: 'dynamicColumnList2',
      stb_s_v_r4: 'dynamicColumnList2',
      // 单行分类
      stb_s_h_r6_category: 'dynamicColumnList2',
      //双行分类
      stb_d_h_r6r6_category: 'dynamicColumnList2',
      //静态模板
      stb_fix1: 'dynamicColumnList1',
      stb_fix2: 'dynamicColumnList1',
      stb_fix3: 'dynamicColumnList1',
      stb_fix4: 'dynamicColumnList1',
      stb_fix5: 'dynamicColumnList1',
      stb_fix6: 'dynamicColumnList1',
      stb_fix7: 'dynamicColumnList1',
      // 手机端模板控件
      phone_s_h_r1_recommend: 'dynamicColumnList1',
      phone_d_v_r3r3: 'dynamicColumnList2',
      phone_s_h_r2: 'dynamicColumnList2',
      phone_s_v_r3: 'dynamicColumnList2',
      phone_m_v_r3rn: 'dynamicColumnList2',
      phone_history: 'dynamicColumnList2'
    };
    const columnConfig = reactive({
      dynamicColumnList1: [{
        label: '序号',
        prop: 'serial',
        width: 100
      }, {
        label: '推荐位名称',
        prop: 'name',
        width: 200
      }, {
        label: '推荐位内容名称',
        width: 200,
        prop: 'content' // formatter: (value: any) => {
        // }

      }, {
        label: '状态',
        prop: 'status',
        // cellSlot: true,
        width: 150,
        formatter: value => {
          if (value != undefined && value != null) {
            return `<span style="color: ${STATUS_FIELD[value].color}">${STATUS_FIELD[value].value}</span>`;
          }
        }
      }, {
        label: '运营区域',
        prop: 'region',
        width: 170,
        formatter: val => val == 'All' || !val ? t('不限') : val
      }, {
        label: '智能推荐',
        prop: 'dynamicRecommend',
        width: 150,
        cellSlot: true,
        controller: () => {
          return pageParams?.moduleType === 'VOD_PRO';
        }
      }, {
        label: '推荐方式',
        prop: 'recommendedType',
        width: 170,
        cellSlot: true,
        formatter: value => {
          if (value == 'topic') {
            return t('manual-by-topic');
          }

          return value && t(value);
        },
        controller: config => {
          // controller 函数可以访问组件作用域内的 props.dynamicData.templateCode
          // config 参数是当前列的配置对象
          const templateCode = props.dynamicData.templateCode; // 可以根据 templateCode 来控制列的显示/隐藏 
          // 盒端模板：stb_d_h_r1r6_recommended 不显示

          return templateCode !== 'stb_d_h_r1r6_recommended';
        }
      }, {
        label: '显示周期',
        prop: 'period',
        formatter: value => {
          return value == '0000-00-00 00:00:00-0000-00-00 00:00:00' ? t('不限') : value;
        }
      }, {
        label: '操作',
        prop: 'options',
        cellSlot: true,
        showOverflowTooltip: false,
        fixed: 'right',
        width: 250 // widgetType: 'buttons',

      }],
      dynamicColumnList2: [{
        label: '序号',
        prop: 'serial',
        width: 100
      }, {
        label: '分类名称',
        prop: 'content' // formatter: (val) => {
        //   // if(!val) return ''
        //   // let findItem = props.categoryOptions.filter(item=> item.id == val)
        //   // return findItem.length? findItem[0].name : ''
        // }

      }, {
        label: '运营区域',
        prop: 'region',
        formatter: val => val == 'All' || !val ? t('不限') : val
      }, {
        label: '推荐顺序',
        prop: 'recommendedSort',
        cellSlot: true
      }, {
        label: '操作',
        prop: 'options',
        cellSlot: true,
        showOverflowTooltip: false,
        fixed: 'right' // widgetType: 'buttons',

      }]
    }); // 新增多语言标题

    const onAddLang = async row => {
      try {
        const {
          code,
          data
        } = await editThemeTitleApi(row);

        if (code == 0) {
          ElMessage({
            type: 'success',
            message: t('编辑成功')
          });
          emits('onUpdateList');
        }
      } catch (error) {}
    }; // 推荐方式改变


    const onRecommendedTypeChange = async (row, val) => {
      loading.value = true;

      try {
        let params = {
          id: row.id,
          recommendedType: row.recommendedType
        };
        const res = await editDynamicPlanRecommendApi(params);

        if (res.code == '0') {
          elMessage('success', '编辑成功');
          emits('onUpdateList');
        }
      } catch (error) {
        console.log('1058-error', error);
        emits('onUpdateList');
      }

      loading.value = false;
    }; // 获取标题||二级标题


    const getTitleText = (titleArr, type) => {
      if (!titleArr || !titleArr.length) return ''; // 默认显示英文标题

      let enTitleText = titleArr.find(item => item.language == 'en')?.title;
      return enTitleText ? enTitleText : titleArr[0][type];
    }; // 获取分类标题


    const getCategoryTitle = (titleArr, index) => {
      if (index === undefined) return '';
      let targetItem = titleArr[0]?.categoryList[index] ? titleArr[0]?.categoryList[index] : undefined;
      return targetItem ? targetItem.title : '';
    }; // 打开配置弹框


    const openTableConfig = row => {
      configObj.value.visible = true;
      configObj.value.data = row;
    }; // 配置完成通知父组件调接口更新


    const handleOk = row => {
      console.log('handleOk', row);
      emits('configOk', row);
    }; // 添加计算属性控制是否显示标题编辑


    const showTitleEdit = computed(() => {
      return props.dynamicData.templateCode && props.dynamicData.templateCode !== 'stb_d_h_r1r6_recommended' && props.dynamicData.templateCode !== 'phone_s_h_r1_recommend' && props.dynamicData.templateCode !== 'stb_s_h_r6_category' && props.dynamicData.templateCode !== 'stb_d_h_r6r6_category' && !/stb_fix\d/.test(props.dynamicData.templateCode);
    }); // 智能推荐改变

    const onDynamicRecommendChange = async (row, val) => {
      try {
        console.log('row', row);
        let params = {
          itemId: row.id,
          dynamicRecommend: val,
          programLanguage: row.dynamicProgramLanguage,
          programType: row.dynamicProgramType
        };
        const {
          code,
          data
        } = await switchDynamicPlanRecommendApi(params);

        if (code == 0) {
          ElMessage({
            type: 'success',
            message: t('操作成功')
          });
          emits('onUpdateList');
        }
      } catch (error) {
        row.dynamicRecommend = !val;
      }
    };

    const pageParams = inject('pageParams'); // 使用 watch 动态配置 formList

    watch(() => props.dynamicData, newVal => {
      if (!newVal) return; // 重置基础配置

      headerConfig.formData = newVal.componentTitleList || []; // 子分类-终端名称|| 分类终端名称 给默认值
      //   if(!headerConfig.formData || !headerConfig.formData.length) {
      //     headerConfig.formData = [{title: '', vodplusDynamicOperationPlanThemeComponentId: newVal.id, language: 'en'}]
      //   }
      // 给推荐顺序设置默认值

      props.dynamicData.themeComponentItemList?.forEach(item => {
        item.extra = item.extra || {
          recommendedSort: ''
        };
      }); // 根据模板类型配置不同的 formList

      if (newVal.templateCode === 'stb_left_side_property') {
        let subCategoryIdList = newVal.themeComponentItemList[0].extra.subCategoryId ? newVal.themeComponentItemList[0].extra.subCategoryId : []; // 左侧属性模板的特殊配置
        // 由关联的子分类extra.subCategoryId数量控制

        headerConfig.formList = subCategoryIdList.map((item, index) => ({
          label: `${t('子分类')}${index + 1}-${t('终端名称')}`,
          prop: index === 0 ? 'title' : 'secondTitle',
          widgetType: 'input',
          itemSlot: true,
          dialogType: 1,
          titleIndex: index
        }));
      } else {
        // 默认配置
        headerConfig.formList = [{
          label: '分类终端名称',
          prop: 'title',
          widgetType: 'input',
          itemSlot: true,
          dialogType: 0,
          controller: () => true
        }];
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_popover = _resolveComponent("el-popover");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_button = _resolveComponent("el-button");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(["header-container", {
          'flex-end': !_unref(showTitleEdit)
        }])
      }, [_unref(showTitleEdit) ? (_openBlock(), _createBlock(DynamicTableHeader, {
        key: 0,
        labelWidth: "120px",
        "form-list": headerConfig.formList,
        "form-data": headerConfig.formData,
        class: "dy_header"
      }, {
        itemSlot: _withCtx(scope => [_createElementVNode("div", {
          class: "out_border",
          onClick: $event => handleOpenLangDialog(headerConfig.formData, scope.dialogType)
        }, [scope.dialogType === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("span", null, _toDisplayString(getTitleText(__props.dynamicData.componentTitleList, 'title')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getCategoryTitle(__props.dynamicData.componentTitleList, scope.titleIndex)), 1))], 8, _hoisted_1)]),
        _: 1
      }, 8, ["form-list", "form-data"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [__props.dynamicData.templateCode !== 'stb_d_h_r6r6_category' && __props.dynamicData.templateCode !== 'stb_left_side_property' && !/stb_fix\d/.test(__props.dynamicData.templateCode) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _imports_0,
        style: {
          "margin-right": "5px",
          "cursor": "pointer"
        },
        onClick: _cache[0] || (_cache[0] = $event => openTableConfig(__props.dynamicData))
      })) : _createCommentVNode("", true), _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 310,
        trigger: "hover"
      }, {
        reference: _withCtx(() => [_hoisted_5]),
        default: _withCtx(() => [_createElementVNode("img", {
          src: __props.dynamicData.layoutImage,
          style: {
            "width": "282px"
          },
          alt: ""
        }, null, 8, _hoisted_6)]),
        _: 1
      })])], 2), _createVNode(_component_common_table, {
        ref: "tableRef",
        options: tableConfig.config,
        style: {
          "width": "100%"
        },
        "table-config": { ...tableConfig,
          data: __props.dynamicData.themeComponentItemList || []
        },
        "pagination-config": tableConfig.paginationConfig
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": _unref(computTableType)
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'dynamicRecommend' ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_9]),
            content: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('开启后根据智能配置信息，每周自动更新一次推荐位内容')), 1)]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(({
            row,
            column
          }) => [column.property == 'recommendedSort' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_select, {
            "model-value": row.extra?.recommendedSort ?? '',
            onChange: value => onRecommendedSortChange(row, value)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sortOperations, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["model-value", "onChange"])])) : _createCommentVNode("", true), column.property == 'recommendedType' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_select, {
            modelValue: row.recommendedType,
            "onUpdate:modelValue": $event => row.recommendedType = $event,
            onChange: value => onRecommendedTypeChange(row, value)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recommendTypeOperations), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])])) : _createCommentVNode("", true), column.property == 'dynamicRecommend' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [row.recommendedType == 'video' ? (_openBlock(), _createBlock(_component_el_switch, {
            key: 0,
            modelValue: row.dynamicRecommend,
            "onUpdate:modelValue": $event => row.dynamicRecommend = $event,
            onChange: value => onDynamicRecommendChange(row, value)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), column.property == 'options' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableOptionsBtn.value, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [item.label == '上传图片' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [row.pictureList && item.controller(row) ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              width: 220,
              trigger: "hover",
              placement: "top"
            }, {
              reference: _withCtx(() => [_createElementVNode("span", null, [item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
                key: 0,
                style: {
                  "margin-left": "0"
                }
              }, item, {
                type: item.type || 'primary',
                link: "",
                onClick: $event => item.func(row)
              }), {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
                _: 2
              }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)])]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.pictureList || [], (item, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index
                }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_14, _toDisplayString(item.posterType == 'common' ? _ctx.$t('通用') : item.posterType == 'android' ? _ctx.$t('安卓') : _ctx.$t('手机')), 1), _createElementVNode("img", {
                  style: {
                    "width": "100%",
                    "height": "100%"
                  },
                  src: item.imageUrl,
                  alt: ""
                }, null, 8, _hoisted_15)])]);
              }), 128))]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), !row.pictureList && item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
              key: 1,
              style: {
                "margin-left": "0"
              }
            }, item, {
              type: item.type || 'primary',
              link: "",
              onClick: $event => item.func(row)
            }), {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
              _: 2
            }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), item.label !== '上传图片' && item.controller(row) ? (_openBlock(), _createBlock(_component_el_button, _mergeProps({
              key: 1,
              style: {
                "margin-left": "0"
              }
            }, item, {
              type: item.type || 'primary',
              link: "",
              onClick: $event => item.func(row)
            }), {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(item.label)), 1)]),
              _: 2
            }, 1040, ["type", "onClick"])) : _createCommentVNode("", true)], 64);
          }), 128))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["options", "table-config", "pagination-config"]), _createVNode(MultiLangDialog, {
        modelValue: langObj.value.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => langObj.value.visible = $event),
        componentId: langObj.value.componentId,
        data: langObj.value.data,
        mode: langObj.value.mode,
        onOnAddLang: onAddLang
      }, null, 8, ["modelValue", "componentId", "data", "mode"]), _createVNode(TwoLangDialog, {
        modelValue: twoLangObj.value.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => twoLangObj.value.visible = $event),
        componentId: twoLangObj.value.componentId,
        "category-count": twoLangObj.value.categoryCount,
        data: twoLangObj.value.data,
        subCategoryIdList: twoLangObj.value.subCategoryIdList,
        onOnAddLang: onAddLang
      }, null, 8, ["modelValue", "componentId", "category-count", "data", "subCategoryIdList"]), _createVNode(TableConfigDialog, {
        modelValue: configObj.value.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => configObj.value.visible = $event),
        rowData: configObj.value.data,
        onConfigOk: handleOk
      }, null, 8, ["modelValue", "rowData"]), _createVNode(RecommendConfig, {
        modelValue: recommendObj.value.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => recommendObj.value.visible = $event),
        data: recommendObj.value.data,
        onUpdateList: _cache[5] || (_cache[5] = $event => emits('onUpdateList'))
      }, null, 8, ["modelValue", "data"])], 64);
    };
  }

});